<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t('sub_category') }}</h4>
        </div>
      </div>
      <div class="page-btn">
        <a href="#" class="btn btn-added" data-bs-toggle="modal" data-bs-target="#create-modal">
          <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t('add_new_sub_category') }}
        </a>
        <CreateModal
          :categories="categories"
          @create_success="onSubCategoryCreated"
        />
      </div>
    </div>

    <ThemeDataTable
      ref="subCategoryTable"
      table-id="SubCategoryTable"
      :fetch-data="fetchSubCategoriesPage"
      :filters="tableFilters"
    >
      <template #default="{ rows }">
        <thead class="thead-light">
          <tr>
            <th>{{ $t('category') }}</th>
            <th>{{ $t('sub_category') }}</th>
            <th class="no-sort text-end">{{ $t('action') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="sub_category in rows" :key="sub_category.id">
            <td>{{ sub_category.parent_category }}</td>
            <td>{{ sub_category.node }}</td>
            <td class="action-table-data text-end">
              <div class="edit-delete-action justify-content-end">
                <a class="me-2 p-2" href="#" @click.prevent="openEditModal(sub_category)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ti ti-edit">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </ThemeDataTable>

    <EditModal
      :categories="categories"
      :selectedSubCategory="selectedSubCategory"
      @edit_success="reloadTable"
    />
  </div>
</template>

<script>
import CreateModal from '@/views/admin_dashboard/sub_category/CreateModal.vue';
import EditModal from '@/views/admin_dashboard/sub_category/EditModal.vue';
import ThemeDataTable from '@/components/common/ThemeDataTable.vue';
import apiUrls from '@/urls';

export default {
  components: {
    CreateModal,
    EditModal,
    ThemeDataTable,
  },
  data() {
    return {
      selectedSubCategory: {},
      categories: [],
      filterOptions: {
        category: [],
      },
    };
  },
  computed: {
    tableFilters() {
      return [
        {
          key: 'category',
          label: this.$t('category'),
          options: this.filterOptions.category,
        },
      ];
    },
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await this.$axios.get(apiUrls.categories.get);
        this.categories = response.data || [];
        this.filterOptions.category = this.categories
          .map((c) => c.node)
          .filter(Boolean);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    },

    openEditModal(sub_category) {
      this.selectedSubCategory = sub_category;
      this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('edit-modal'));
        modal.show();
      });
    },

    reloadTable() {
      this.$refs.subCategoryTable?.reload?.();
    },

    onSubCategoryCreated() {
      this.fetchCategories();
      this.reloadTable();
    },

    async fetchSubCategoriesPage({ draw, start, length, search, orderColumn, orderDir, filters }) {
      const params = {
        draw,
        start,
        length,
        'search[value]': search || '',
        'order[0][column]': orderColumn,
        'order[0][dir]': orderDir,
        ...filters,
      };

      const response = await this.$axios.get(apiUrls.sub_categories.get, { params });
      const payload = response.data || {};

      return {
        data: payload.data || [],
        recordsTotal: payload.recordsTotal || 0,
        recordsFiltered: payload.recordsFiltered || 0,
      };
    },
  },
  created() {
    this.fetchCategories();
  },
};
</script>

<style scoped>
:deep(table .edit-delete-action.justify-content-end) {
  justify-content: flex-end !important;
}
:deep(td.action-table-data.text-end) {
  text-align: right !important;
}
</style>
